import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  q: '¿Tengo que comprar suplementos caros?',
  a: 'No. El protocolo se basa en cambios de comportamiento y temperatura.'
}, {
  q: '¿Cuánto tiempo tarda en funcionar?',
  a: 'Muchos hombres reportan su primera noche de 7 horas seguidas tras aplicar el protocolo de higiene térmica el primer día.'
}, {
  q: '¿Es difícil de seguir?',
  a: 'Está diseñado para hombres ocupados. Las acciones toman menos de 10 minutos en total al día.'
}];
export function FAQSection() {
  return <section className="w-full bg-midnight-deep py-24 px-6 border-y border-cyan-signal/10" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-16">
          <h2 className="font-display text-3xl md:text-5xl text-bone uppercase leading-tight" data-id="element-17">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-midnight p-8 border border-cyan-signal/10" data-id="element-19">
              <h3 className="text-xl font-bold text-bone mb-4 uppercase tracking-wide" data-id="element-20">
                {faq.q}
              </h3>
              <p className="text-steel leading-relaxed" data-id="element-21">{faq.a}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}